import { IDogClass } from "./dog-class.interface";

export class IScoreDogClass {
  //
  score_id: string;

  dog_class: IDogClass;
}
